/* Gymatics cart discount code box (25 Oct 2026).
   Adds "Have a discount code?" to the cart drawer (above the totals) and the cart page, so codes such as BuddyRep
   personal codes are applied to the basket BEFORE the shopper taps Apple Pay / Shop Pay / Checkout. Express wallets
   skip the checkout page where codes are normally typed, which is how order GYMATICS-2621 missed EMILYBUDDYREP.
   Codes are applied with Shopify's /cart/update.js { discount } so the checkout and every wallet see the same price.
   The theme re-renders the drawer/cart footer on every change, so the box is re-added by an observer. */
(function () {
  'use strict';
  if (window.GymaticsCartDiscount) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var typed = '', message = null, busy = false, cartCache = null, open = false;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function getCart() { return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; }); }
  function setCodes(codes) {
    return fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }) }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; });
  }
  function activeCodes(cart) { return ((cart && cart.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }); }

  function refreshTheme() {
    if (document.getElementById('main-cart-items')) { location.reload(); return; }
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gymatics-cart-discount' }); } catch (_) {} }
    if (window.GymaticsDeliveryProgress && GymaticsDeliveryProgress.refresh) GymaticsDeliveryProgress.refresh();
  }

  function apply(code) {
    code = String(code || '').trim();
    if (!code || busy) return;
    if (!/^[A-Za-z0-9_-]{2,60}$/.test(code)) { message = { kind: 'error', text: 'Check the code and try again.' }; paintAll(); return; }
    busy = true; message = null; paintAll();
    getCart().then(function (cart) {
      var keep = activeCodes(cart).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      return setCodes(keep.concat([code])).then(function (after) {
        var hit = (after.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (hit && hit.applicable) { typed = ''; message = { kind: 'ok', text: code.toUpperCase() + ' applied.' }; open = true; return; }
        // Not valid for this basket: take it back off so it doesn't sit there doing nothing.
        message = { kind: 'error', text: code.toUpperCase() + ' isn\'t valid for the items in your basket.' };
        return setCodes(keep);
      });
    }).catch(function () { message = { kind: 'error', text: 'Couldn\'t apply the code. Please try again.' }; })
      .finally(function () { busy = false; refreshTheme(); paintAll(); });
  }

  function removeCode(code) {
    if (busy) return;
    busy = true; message = null; paintAll();
    getCart().then(function (cart) { return setCodes(activeCodes(cart).filter(function (c) { return c !== code; })); })
      .catch(function () {}).finally(function () { busy = false; refreshTheme(); paintAll(); });
  }

  function html() {
    var codes = activeCodes(cartCache);
    var chips = codes.map(function (c) {
      return '<span class="gcd__chip"><span>' + esc(c.toUpperCase()) + '</span><button type="button" data-gcd-remove="' + esc(c) + '" aria-label="Remove code ' + esc(c) + '">×</button></span>';
    }).join('');
    var isOpen = open || codes.length > 0 || !!message;
    return '<details class="gcd"' + (isOpen ? ' open' : '') + '><summary>Have a discount code?</summary>' +
      '<form class="gcd__form" novalidate><label class="gcd__sr" for="gcd-input-%ID%">Discount code</label>' +
      '<input id="gcd-input-%ID%" class="gcd__input" name="code" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Enter code" value="' + esc(typed) + '"' + (busy ? ' disabled' : '') + '>' +
      '<button type="submit" class="gcd__btn"' + (busy ? ' disabled' : '') + '>' + (busy ? 'Applying…' : 'Apply') + '</button></form>' +
      (chips ? '<div class="gcd__chips">' + chips + '</div>' : '') +
      (message ? '<p class="gcd__msg is-' + message.kind + '" role="status">' + esc(message.text) + '</p>' : '') +
      '</details>';
  }

  var seq = 0;
  function paint(host) {
    var id = host.getAttribute('data-gcd-id') || String(++seq);
    host.setAttribute('data-gcd-id', id);
    var had = host.querySelector('.gcd__input') === document.activeElement;
    host.innerHTML = html().replace(/%ID%/g, id);
    var form = host.querySelector('form'), input = host.querySelector('.gcd__input'), det = host.querySelector('details');
    input.addEventListener('input', function () { typed = input.value; });
    det.addEventListener('toggle', function () { open = det.open; });
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(input.value); });
    host.querySelectorAll('[data-gcd-remove]').forEach(function (b) { b.addEventListener('click', function () { removeCode(b.getAttribute('data-gcd-remove')); }); });
    if (had && !busy) input.focus();
  }
  function paintAll() { document.querySelectorAll('[data-gcd]').forEach(paint); }

  function ensure() {
    // Drawer: just above the discounts list / totals / checkout button.
    var drawerFooter = document.querySelector('cart-drawer .drawer__footer .cart-drawer__footer');
    if (drawerFooter && !drawerFooter.parentNode.querySelector(':scope > [data-gcd]')) {
      var a = document.createElement('div'); a.setAttribute('data-gcd', 'drawer'); a.className = 'gcd-host gcd-host--drawer';
      drawerFooter.parentNode.insertBefore(a, drawerFooter); paint(a);
    }
    // Cart page: above the subtotal/totals block (.js-contents keeps its element; only its innerHTML is replaced).
    var pageTotals = document.querySelector('#main-cart-footer .js-contents');
    if (pageTotals && !pageTotals.parentNode.querySelector(':scope > [data-gcd]')) {
      var b = document.createElement('div'); b.setAttribute('data-gcd', 'page'); b.className = 'gcd-host gcd-host--page';
      pageTotals.parentNode.insertBefore(b, pageTotals); paint(b);
    }
  }

  var css =
    '.gcd-host{font-family:var(--gc-font,inherit);color:var(--gc-ink,#0b1726)}.gcd-host--drawer{margin:0 0 12px}.gcd-host--page{margin:0 0 16px}' +
    '.gcd summary{cursor:pointer;list-style:none;display:inline-flex;align-items:center;gap:6px;font:700 14px/1.3 var(--gc-font,inherit);color:var(--gc-navy,#091d33);padding:4px 0}' +
    '.gcd summary::-webkit-details-marker{display:none}.gcd summary::after{content:"+";font-weight:800;color:var(--gc-orange,#f58220)}.gcd[open] summary::after{content:"\\2212"}' +
    '.gcd__form{display:flex;gap:8px;margin-top:8px}.gcd__sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)}' +
    '.gcd__input{flex:1 1 auto;min-width:0;min-height:46px;padding:10px 14px;border:1.5px solid var(--gc-line,#e3e8ee);border-radius:14px;background:var(--gc-field,#f8fafb);color:var(--gc-ink,#0b1726);font:500 15px/1.4 var(--gc-font,inherit);text-transform:uppercase;letter-spacing:.04em}' +
    '.gcd__input::placeholder{text-transform:none;letter-spacing:0;color:var(--gc-muted,#566270)}' +
    '.gcd__input:focus{outline:none;border-color:var(--gc-navy,#091d33);box-shadow:0 0 0 5px rgba(245,130,32,.16)}' +
    '.gcd__btn{flex:none;min-height:46px;padding:0 18px;border:0;border-radius:16px;background:#fff;box-shadow:inset 0 0 0 1.5px var(--gc-line,#e3e8ee);color:var(--gc-navy,#091d33);font:700 14px/1.2 var(--gc-font,inherit);cursor:pointer}' +
    '.gcd__btn:hover{box-shadow:inset 0 0 0 1.5px var(--gc-navy,#091d33)}.gcd__btn:disabled,.gcd__input:disabled{opacity:.6;cursor:default}' +
    '.gcd__btn:focus-visible,.gcd summary:focus-visible,.gcd__chip button:focus-visible{outline:3px solid var(--gc-orange,#f58220);outline-offset:2px}' +
    '.gcd__chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}.gcd__chip{display:inline-flex;align-items:center;gap:4px;padding:4px 6px 4px 12px;border-radius:999px;background:#fff1e5;color:var(--gc-navy,#091d33);font:700 13px/1.2 var(--gc-font,inherit)}' +
    '.gcd__chip button{width:24px;height:24px;border:0;border-radius:50%;background:transparent;color:inherit;font-size:16px;line-height:1;cursor:pointer}' +
    '.gcd__msg{margin:8px 0 0;font:600 13px/1.4 var(--gc-font,inherit)}.gcd__msg.is-ok{color:var(--gc-green,#157f4a)}.gcd__msg.is-error{color:var(--gc-red,#b42318)}';

  function start() {
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
    getCart().then(function () { ensure(); paintAll(); }).catch(ensure);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; ensure(); });
    }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'gymatics-cart-discount') getCart().then(paintAll); });
    }
  }

  window.GymaticsCartDiscount = { apply: apply };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
